// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Manrope-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/Poppins-Medium.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@tailwind base;
@tailwind components;
@tailwind utilities;

@font-face {
  font-family: Manrope;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-weight: 100 900;
  font-stretch: 50% 200%;
}

@font-face {
  font-family: Poppins;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-weight: 500;
}

:root {
  --primary: #514BFF;
  --on-primary: #FFFFFF;
  --secondary: #FFA96F;
  --on-secondary: #FFFFFF;
  --background-color: #FFFFFF;
  --background-color-dark: #F2F2F2;
  --background-color-darker: #EBEBEB;
  --text-color: #1E1E1E; 
  --text-color-alt: #1E1E1E99;
  --text-color-grey: #777777;
  --input-field-color: #F2F2F2;
  --alt-button-color: #F6F6F6;
  --black-button-color: #130F26;
  --grey: #C8C8C8;
}



html * {
  font-family: Manrope, Arial;
  font-size: 1rem;
  color: var(--text-color)
}

input[type=text], input[type=password], select {
  width: 20.875rem;
  height: 3.3125rem;
  flex-shrink: 0;
  border-radius: 0.875rem; 
  background: var(--background-color-dark);
  font-weight: 600;
  box-sizing: border-box;
  padding: 1rem 1.31rem 0.94rem 1.31rem;
}

h1 {
  font-size: 1.5rem;
  font-weight: 600;
}

h4 {
  font-weight: 500;
}

.grey {
  color: var(--text-color-grey);
}


input[type=text]::placeholder, input[type=password]::placeholder {
  color: var(--text-color-alt);
  font-weight: 400;

}

input[type="checkbox"] {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 0.375rem; 
  flex-shrink: 0;
  color: var(--background-color-dark);
  accent-color: var(--primary);
}

a:link.always-active, a:visited.always-active {
  color: var(--primary);
  font-weight: 600;
}

.heading {
  font-weight: 600;
  font-size: 20px;
}

`, "",{"version":3,"sources":["webpack://./src/components/styles/global.css"],"names":[],"mappings":"AAAA,cAAc;AACd,oBAAoB;AACpB,mBAAmB;;AAEnB;EACE,oBAAoB;EACpB,4CAAiD;EACjD,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,4CAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,2BAA2B;EAC3B,gCAAgC;EAChC,kCAAkC;EAClC,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,eAAe;AACjB;;;;AAIA;EACE,2BAA2B;EAC3B,eAAe;EACf;AACF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,wCAAwC;EACxC,gBAAgB;EAChB,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;;AAGA;EACE,4BAA4B;EAC5B,gBAAgB;;AAElB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,cAAc;EACd,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@font-face {\n  font-family: Manrope;\n  src: url('./fonts/Manrope-VariableFont_wght.ttf');\n  font-weight: 100 900;\n  font-stretch: 50% 200%;\n}\n\n@font-face {\n  font-family: Poppins;\n  src: url(\"./fonts/Poppins-Medium.ttf\");\n  font-weight: 500;\n}\n\n:root {\n  --primary: #514BFF;\n  --on-primary: #FFFFFF;\n  --secondary: #FFA96F;\n  --on-secondary: #FFFFFF;\n  --background-color: #FFFFFF;\n  --background-color-dark: #F2F2F2;\n  --background-color-darker: #EBEBEB;\n  --text-color: #1E1E1E; \n  --text-color-alt: #1E1E1E99;\n  --text-color-grey: #777777;\n  --input-field-color: #F2F2F2;\n  --alt-button-color: #F6F6F6;\n  --black-button-color: #130F26;\n  --grey: #C8C8C8;\n}\n\n\n\nhtml * {\n  font-family: Manrope, Arial;\n  font-size: 1rem;\n  color: var(--text-color)\n}\n\ninput[type=text], input[type=password], select {\n  width: 20.875rem;\n  height: 3.3125rem;\n  flex-shrink: 0;\n  border-radius: 0.875rem; \n  background: var(--background-color-dark);\n  font-weight: 600;\n  box-sizing: border-box;\n  padding: 1rem 1.31rem 0.94rem 1.31rem;\n}\n\nh1 {\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n\nh4 {\n  font-weight: 500;\n}\n\n.grey {\n  color: var(--text-color-grey);\n}\n\n\ninput[type=text]::placeholder, input[type=password]::placeholder {\n  color: var(--text-color-alt);\n  font-weight: 400;\n\n}\n\ninput[type=\"checkbox\"] {\n  width: 1.5rem;\n  height: 1.5rem;\n  border-radius: 0.375rem; \n  flex-shrink: 0;\n  color: var(--background-color-dark);\n  accent-color: var(--primary);\n}\n\na:link.always-active, a:visited.always-active {\n  color: var(--primary);\n  font-weight: 600;\n}\n\n.heading {\n  font-weight: 600;\n  font-size: 20px;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
